// Mock data for patient admissions
export const admissionsMockData = [
  {
    admissionId: 'ADM-1001',
    patientId: 'PT-1001',
    patientName: 'John Smith',
    dateOfAdmission: '2023-08-15T09:30:00',
    admissionStatus: 'Active',
    department: 'Cardiology',
    attendingPhysician: 'Dr. Sarah Johnson',
    roomAssigned: 'A-201'
  },
  {
    admissionId: 'ADM-1002',
    patientId: 'PT-1023',
    patientName: 'Emma Wilson',
    dateOfAdmission: '2023-08-14T14:45:00',
    admissionStatus: 'Active',
    department: 'Orthopedics',
    attendingPhysician: 'Dr. Robert Chen',
    roomAssigned: 'B-105'
  },
  {
    admissionId: 'ADM-1003',
    patientId: 'PT-1045',
    patientName: 'Michael Brown',
    dateOfAdmission: '2023-08-10T11:15:00',
    admissionStatus: 'Discharged',
    department: 'General Surgery',
    attendingPhysician: 'Dr. Emily Taylor',
    roomAssigned: 'C-310'
  },
  {
    admissionId: 'ADM-1004',
    patientId: 'PT-1067',
    patientName: 'Sarah Davis',
    dateOfAdmission: '2023-08-12T16:20:00',
    admissionStatus: 'Active',
    department: 'Neurology',
    attendingPhysician: 'Dr. James Wilson',
    roomAssigned: 'A-105'
  },
  {
    admissionId: 'ADM-1005',
    patientId: 'PT-1089',
    patientName: 'David Martinez',
    dateOfAdmission: '2023-08-09T10:00:00',
    admissionStatus: 'Discharged',
    department: 'Cardiology',
    attendingPhysician: 'Dr. Sarah Johnson',
    roomAssigned: 'A-210'
  },
  {
    admissionId: 'ADM-1006',
    patientId: 'PT-1102',
    patientName: 'Jennifer Lee',
    dateOfAdmission: '2023-08-16T08:45:00',
    admissionStatus: 'Active',
    department: 'Pulmonology',
    attendingPhysician: 'Dr. Michael Chang',
    roomAssigned: 'D-112'
  },
  {
    admissionId: 'ADM-1007',
    patientId: 'PT-1125',
    patientName: 'Robert Johnson',
    dateOfAdmission: '2023-08-15T13:30:00',
    admissionStatus: 'Active',
    department: 'Gastroenterology',
    attendingPhysician: 'Dr. Linda Chen',
    roomAssigned: 'B-203'
  },
  {
    admissionId: 'ADM-1008',
    patientId: 'PT-1142',
    patientName: 'Patricia White',
    dateOfAdmission: '2023-08-11T15:20:00',
    admissionStatus: 'Discharged',
    department: 'Orthopedics',
    attendingPhysician: 'Dr. Robert Chen',
    roomAssigned: 'B-110'
  },
  {
    admissionId: 'ADM-1009',
    patientId: 'PT-1167',
    patientName: 'Thomas Wilson',
    dateOfAdmission: '2023-08-13T09:10:00',
    admissionStatus: 'Active',
    department: 'Urology',
    attendingPhysician: 'Dr. Jessica Kim',
    roomAssigned: 'C-105'
  },
  {
    admissionId: 'ADM-1010',
    patientId: 'PT-1184',
    patientName: 'Elizabeth Brown',
    dateOfAdmission: '2023-08-08T11:45:00',
    admissionStatus: 'Discharged',
    department: 'General Surgery',
    attendingPhysician: 'Dr. Emily Taylor',
    roomAssigned: 'C-301'
  },
  {
    admissionId: 'ADM-1011',
    patientId: 'PT-1205',
    patientName: 'James Anderson',
    dateOfAdmission: '2023-08-14T10:30:00',
    admissionStatus: 'Active',
    department: 'Cardiology',
    attendingPhysician: 'Dr. Sarah Johnson',
    roomAssigned: 'A-220'
  },
  {
    admissionId: 'ADM-1012',
    patientId: 'PT-1226',
    patientName: 'Lisa Martinez',
    dateOfAdmission: '2023-08-16T14:15:00',
    admissionStatus: 'Active',
    department: 'Neurology',
    attendingPhysician: 'Dr. James Wilson',
    roomAssigned: 'A-115'
  }
]
